import React from 'react';
import { downloadReport, exhibitorTypeActionId, toastError, toastSuccess, disclaimer } from "../utils/constants";




const Footer = ({ head, userId }) => {
  return (
    <>

      <div className="" style={{ bottom: '0px !important' }}>
        <div className='footer-out' style={{ position: 'fixed', bottom: '0px' }}>
          <div className="footer-sec">
            <strong>Disclaimer and Ownership:</strong>{disclaimer}
          </div>
          <div className="footer-first">
            ITME All Rights Reserved <i class="fa fa-copyright"></i> 2025
          </div>
        </div>
      </div>

    </>
  );
}
export default Footer;